<template>
  <div style="padding: 1%" id="frameContainer">
    <div class="display-1" style="text-align: left;">
      Gedenkseiten von {{ name }}
    </div>
    <eternio-explore-block :hideBtn="hideBtn" :data="data" :clamp="false" :loading="loading" @loadMore="loadBlock"></eternio-explore-block>
  </div>
</template>

<script>
import ExploreBlock from '@/components/explore/ExploreBlock.vue'
import axios from 'axios'

export default {
  props: ['partner_id', 'name'],
  data () {
    return {
      data: {},
      loading: true,
      hideBtn: false
    }
  },
  components: {
    eternioExploreBlock: ExploreBlock
  },
  methods: {
    loadBlock () {
      if (this.data) {
        axios.get('/search/partner', { params: { set: Math.ceil(this.data.length / 10), p_id: this.partner_id } })
          .then(res => {
            if (res.data.length > 0) {
              this.data = this.data.concat(res.data)
              if (res.data.length < 10) this.hideBtn = true
            } else {
              this.hideBtn = true
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  },
  created () {
    // Get Recent
    axios.get('/search/partner', { params: { p_id: this.page.page_id } })
      .then(res => {
        this.loading = false
        this.data = res.data
        if (res.data.length < 10) this.hideBtn = true
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>
